import { z } from 'zod';

export const privacy_consent = z.literal<boolean>(true, {
  errorMap: () => ({ message: 'Вы должны согласиться с политикой конфиденциальности' }),
});